import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold uppercase tracking-wider rounded-full border border-accent-300/60 text-accent-700 bg-accent-50 mb-4">
            Browse Categories
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            14 Curated Product Categories
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Every category linked directly to detailed spreadsheet comparisons on Pandabuy Sheet — one click away from smarter shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300/60 transition-all duration-200 cursor-pointer"
            >
              <div className="w-full aspect-[5/4] overflow-hidden bg-background-100">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  title={`${cat.name} — Pandabuy Sheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-2.5 text-xs font-medium text-accent-600 group-hover:text-accent-800 transition-colors">
                  View Spreadsheet
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}